import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MedicoModule } from 'app/panel-seccion/medico/medico.module';
import { Router } from '@angular/router';
import { MedicoService } from 'app/services/medico.service';

@Injectable({
  providedIn: 'root'
})
export class MedicoGuard implements CanActivate {
  
  constructor(
    private authService: MedicoService,
    private router: Router
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) : Promise<boolean | UrlTree> {
    return await this.authService.isValidToken().then((value)=>{ 
      if(value) {
        return true;
      }
      else {
        this.router.navigate(['/login-medico']);
        return false
      }
    })
  }
  
}
